import { Res, SaleDTO } from 'core/api';
import { CardPanel } from 'core/ui-next';
import React from 'react';
import { HStack, VStack, Text, Separator } from '@chakra-ui/react';
import { Format } from 'core/ui';

export function LargeDeviceLastSale({ lastSale }: { lastSale: SaleDTO }): React.ReactNode {
	return <CardPanel h='40' w='80' bg={{ base: '{colors.neutral.100}', _dark: '{colors.neutral.800}' }}>
		<VStack gap={'1'}>
			<Text fontSize={'md'} fontWeight={'bold'} color={{ base: '{colors.neutral.500}', _dark: '{colors.neutral.400}' }}>{Res.Web.LAST_SALE_TABLET_LAST_SALE_LBL()}</Text>
			<Text fontSize={'2xl'} fontWeight={'bold'}>{Format.asDocumentNumber(lastSale.SerialNumber.SerieName, lastSale.SerialNumber.Number)}</Text>
		</VStack>
		<Separator width={'full'} marginY={'2'} borderColor={'transparent'} bg={{ base: '{colors.neutral.300}', _dark: '{colors.neutral.300}' }} height={'1.25px'} />
		<HStack width={'full'} justifyContent={'space-between'}>
			<VStack gap={'0'}>
				<Text fontSize={'md'} fontWeight={'bold'}>{Format.asMoney(lastSale.NetAmount)}</Text>
				<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.500}', _dark: '{colors.neutral.400}' }}>{Res.Web.LAST_SALE_TABLET_AMOUNT_LBL()}</Text>
			</VStack>
			<VStack gap={'0'}>
				<Text fontSize={'md'} fontWeight={'bold'}>{Format.asMoney(lastSale.PaidAmount)}</Text>
				<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.500}', _dark: '{colors.neutral.400}' }}>{Res.Web.LAST_SALE_TABLET_PAID_LBL()}</Text>
			</VStack>
			<VStack gap={'0'}>
				<Text fontSize={'md'} fontWeight={'bold'}>{Format.asMoney(lastSale.ChangeAmount)}</Text>
				<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.500}', _dark: '{colors.neutral.400}' }}>{Res.Web.LAST_SALE_TABLET_CHANGE_AMOUNT_LBL()}</Text>
			</VStack>
		</HStack>
	</CardPanel>;
}

export function PhoneLastSale({ lastSale }: { lastSale: SaleDTO }): React.ReactNode {
	return <VStack width={'full'} padding={'6'} background={{ base: 'white', _dark: '{colors.neutral.700}' }} borderRadius='md'>
		<CardPanel h={'34'} w={'full'} bg={{ base: '{colors.neutral.100}', _dark: '{colors.neutral.800}' }}>
			<VStack gap={'1'}>
				<Text fontSize={'md'} fontWeight={'bold'} color={{ base: '{colors.neutral.500}', _dark: '{colors.neutral.400}' }}>{Res.Web.LAST_SALE_TABLET_LAST_SALE_LBL()}</Text>
				<Text fontSize={'xl'} fontWeight={'bold'}>{Format.asDocumentNumber(lastSale.SerialNumber.SerieName, lastSale.SerialNumber.Number)}</Text>
			</VStack>
			<Separator width={'full'} marginY={'2'} borderColor={'transparent'} bg={{ base: '{colors.neutral.300}', _dark: '{colors.neutral.300}' }} height={'1.25px'} />
			<HStack width={'full'} justifyContent={'space-between'}>
				<VStack gap={'0'}>
					<Text fontSize={'sm'} fontWeight={'bold'}>{Format.asMoney(lastSale.NetAmount)}</Text>
					<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.500}', _dark: '{colors.neutral.400}' }}>{Res.Web.LAST_SALE_TABLET_AMOUNT_LBL()}</Text>
				</VStack>
				<VStack gap={'0'}>
					<Text fontSize={'sm'} fontWeight={'bold'}>{Format.asMoney(lastSale.PaidAmount)}</Text>
					<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.500}', _dark: '{colors.neutral.400}' }}>{Res.Web.LAST_SALE_TABLET_PAID_LBL()}</Text>
				</VStack>
				<VStack gap={'0'}>
					<Text fontSize={'sm'} fontWeight={'bold'}>{Format.asMoney(lastSale.ChangeAmount)}</Text>
					<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.500}', _dark: '{colors.neutral.400}' }}>{Res.Web.LAST_SALE_TABLET_CHANGE_AMOUNT_LBL()}</Text>
				</VStack>
			</HStack>
		</CardPanel>
	</VStack>;
}